import React from 'react';
import { Table } from 'react-bootstrap';

/**
 * ValidationErrorsTable component displays a table of validation errors for user import.
 * @component
 * @param {Object[]} errors - Array of validation error objects.
 * @param {number} errors[].row - The row number in the Excel file where the error occurred.
 * @param {string} errors[].email - The email address associated with the row.
 * @param {string[]} errors[].errors - Array of error messages for the row.
 * @returns {JSX.Element|null} A table of validation errors, or null if there are no errors.
 */

const ValidationErrorsTable = ({ errors }) => {
  if (!errors || errors.length === 0) return null;

  return (
    <div className="mb-3">
      <h6 style={{ color: '#EA6759', fontSize: '16px' }}>Validation Errors</h6>
      <Table 
        striped 
        bordered 
        hover 
        size="sm"
        style={{ 
          backgroundColor: 'rgba(116, 232, 199, 0.05)',
          color: 'white',
          borderColor: '#74E8C7'
        }}
      >
        <thead style={{ backgroundColor: 'rgba(116, 232, 199, 0.1)' }}>
          <tr>
            <th style={{ color: '#74E8C7', borderColor: '#74E8C7' }}>Row</th>
            <th style={{ color: '#74E8C7', borderColor: '#74E8C7' }}>Email</th>
            <th style={{ color: '#74E8C7', borderColor: '#74E8C7' }}>Errors</th>
          </tr>
        </thead>
        <tbody>
          {errors.map((error, index) => (
            <tr key={index} style={{ borderColor: '#74E8C7' }}>
              <td style={{ color: 'white', borderColor: '#74E8C7' }}>{error.row}</td>
              <td style={{ color: 'white', borderColor: '#74E8C7' }}>{error.email}</td>
              <td style={{ color: 'white', borderColor: '#74E8C7' }}>
                <ul className="mb-0 pl-3">
                  {error.errors.map((err, i) => (
                    <li key={i} style={{ color: '#EA6759' }}>{err}</li>
                  ))}
                </ul>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default ValidationErrorsTable;